export const resolveUnionTypeByProperty = <T, U>(myType: T | U, property: keyof T): myType is T => {
    return (<T>myType)[property] !== undefined;
};
